// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/28
// +-------------------------------------------------------------
// |Time: 12:15
// +-------------------------------------------------------------
export default [
    {
        path: '/order/order-list/:order_combined_state?',
        name: 'OrderList',
        component: () => import('@/views/Order/Order/Index.vue'),
        meta: {title: '订单记录'},
    },
    {
        path: '/order/create-order',
        name: 'CreateOrder',
        component: () => import('@/views/Order/CreateOrder/Index.vue'),
        meta: {title: '确认购买'},
    },
    {
        path: '/order/pay-details',
        name: 'PayDetails',
        component: () => import('@/views/Order/Order/PayDetails.vue'),
        meta: {title: '支付详情'},
    },
]